<template>
  <Content :title="$t('SUPPORT.CONTACT_US')">
    <Card>
      <p v-dompurify-html="$t('SUPPORT.SUPPORT_INFO')" />
    </Card>
  </Content>
</template>

<script>
import Card from '@@/common/Card';
import Content from '@@/common/layout/Content';
import layout from '@/mixins/layout';

export default {
  name: 'ContactUs',
  components: { Card, Content },
  mixins: [layout],
  created() {
    this.setPageTitle('SUPPORT.CONTACT_US');
  },
};
</script>
